
import {ApolloClient, gql} from '@apollo/client';
import {MutateVars} from 'utils/gqlTypes';

export interface Vars {
	filter: {
		startDate: string
		endDate?: string
		region?: string
		location?: string
	}
	page: {
		first: number
		after?: string
	}
}

export interface Entry {
	date: {
		date: string
		timezone: string
		unix: string
	}

	location: {
		id: string
		details: {
			id: string
			name: string
			slug: string
			address: {
				addr1: string
				addr2: string
			}
			coords: {
				lat: number
				lng: number
			}
			isStore: boolean
			isPrivate: boolean
			notes: string
		}
		photos: {
			urls: string[]
		}
		regions: {
			primary: string
		}
	}

	private: boolean

	appts: {
		id: string
		details: {
			start: {
				time12h: string
				time24h: string
				unix: string
				timezone: string
			}
		}
		canReserve: boolean
	}[]
}

export interface Result {
	events: {
		edges: {
			node: Entry
		}[]
		pageInfo: {
			hasNextPage: boolean
			lastCursor: string
			total: number
		}
	}
}

export const getEvents = (
	client: ApolloClient<object>,
	options: MutateVars<Result, Vars>,
) => (
	client.query<Result, Vars>({
		...options,
		query: gql`
		query (
			$filter: EventsInput,
			$page: PageInput,
		) {
			events(filter: $filter, page: $page) {
				edges {
					node {
						date {
							date
							timezone
							unix
						}
						location {
							id
							details {
								address {
									addr1
									addr2
								}
								coords {
									lat
									lng
								}
								id
								name
								slug
								isStore
								isPrivate
								notes
							}
							photos {
								urls
							}
							regions {
								primary
							}
						}
						private
						appts {
							id
							details {
								product {
									shortName
								}
								start {
									time12h: time(fmt: "3:04 PM")
									time24h: time(fmt: "15:04")
									unix
									timezone
								}
							}
							canReserve
						}
					}
				}
				pageInfo {
					hasNextPage
					lastCursor
					total
				}
			}
		}`,
	})
);
